module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Bubendorf_BL-dfbab7ad6b2939c5cfaff5e7636c4283.svg";